/**  Form控件 shape的类型 */
export var ControlShape;
(function (ControlShape) {
    ControlShape["INPUT"] = "input";
    ControlShape["CHECKBOX"] = "checkbox";
    ControlShape["TEXTAREA"] = "textArea";
    ControlShape["SELECT"] = "select";
    ControlShape["DATETIME"] = "datetime";
    ControlShape["FLOAT"] = "float";
})(ControlShape || (ControlShape = {}));
//# sourceMappingURL=interface.js.map